import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

const SYSTEM_INTEGRATIONS_URL = '/v2/integrations/system';

const omitSystemRequestOnlyFields = (system = {}) => {
  const { id, oldPassword, ...payload } = system;
  return payload;
};

export const integrationsApi = createApi({
  reducerPath: 'integrationsApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['System'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    fusionGetIntegrations: builder.query({
      query: () => ({
        url: SYSTEM_INTEGRATIONS_URL,
      }),
      transformResponse: (response) => response.result || [],
      providesTags: ['System'],
    }),
    fusionAddIntegration: builder.mutation({
      query: (system) => ({
        url: SYSTEM_INTEGRATIONS_URL,
        method: 'POST',
        data: omitSystemRequestOnlyFields(system),
      }),
    }),
    fusionUpdateIntegration: builder.mutation({
      query: (system) => ({
        url: `${SYSTEM_INTEGRATIONS_URL}/${encodeURIComponent(system.id)}`,
        method: 'PATCH',
        data: omitSystemRequestOnlyFields(system),
      }),
    }),
    fusionDeleteIntegration: builder.mutation({
      query: (system) => ({
        url: `${SYSTEM_INTEGRATIONS_URL}/${encodeURIComponent(system.id)}`,
        method: 'DELETE',
      }),
    }),
    fusionVerifyIntegrationPassword: builder.mutation({
      query: ({ systemId, password, email }) => ({
        url: `${SYSTEM_INTEGRATIONS_URL}/${encodeURIComponent(systemId)}/validate`,
        method: 'POST',
        data: { email, password },
      }),
    }),
    getLicenseInfo: builder.query({
      query: () => ({
        url: `${SYSTEM_INTEGRATIONS_URL}/count`,
      }),
      transformResponse: (response) =>
        response?.result?.[0] ?? response?.[0] ?? response?.result ?? response,
    }),
  }),
});

export const {
  useFusionGetIntegrationsQuery,
  useFusionAddIntegrationMutation,
  useFusionUpdateIntegrationMutation,
  useFusionDeleteIntegrationMutation,
  useFusionVerifyIntegrationPasswordMutation,
  useGetLicenseInfoQuery,
} = integrationsApi;
